<div>
    <v-row>
        <v-checkbox
            v-model="caseCost"
            :disabled="caseCostDisabled"
            label="Case cost occurs (€)"
            hide-details
            class="shrink mr-2 my-2 px-3"
            style="min-width: 220px"></v-checkbox>
        <v-text-field
            v-if="caseCost"
            v-model="caseCostValue"
            :rules="caseCostFieldValidationRules"
            placeholder="Enter case cost. Please enter values without €"
            variant="outlined"
            density="compact"
            hint="Amount in € that was spent by NSC or dealership as goodwill."
            persistent-hint></v-text-field>
    </v-row>
    <v-row align="center">
        <v-checkbox
            v-model="discountGranted"
            :disabled="discountGrantedDisabled"
            label="Discount Granted (%)"
            hide-details
            class="shrink mr-2 my-2 px-3"
            style="min-width: 220px"></v-checkbox>
        <v-text-field
            v-if="discountGranted"
            v-model="discountGrantedValue"
            :rules="discountFieldValidationRules"
            placeholder="Enter discount. Please enter values without %"
            variant="outlined"
            density="compact"
            hide-details></v-text-field>
    </v-row>
    <v-row>
        <v-col cols="4" class="py-0">
            <v-checkbox
                v-model="localSolution.costRejection"
                @update:model-value="solutionUpdated"
                label="Cost rejection"
                hide-details
                class="shrink mr-2 my-2"></v-checkbox>
        </v-col>
    </v-row>
    <v-row align="center">
        <v-checkbox
            v-model="detailedConsalting"
            label="Detailed consulting"
            hide-details
            class="shrink mr-2 my-2 px-3"
            style="min-width: 220px"></v-checkbox>
        <v-text-field
            v-if="detailedConsalting"
            v-model="localSolution.detailedConsalting"
            :rules="textFieldValidationRules"
            placeholder="Enter detailed consulting"
            variant="outlined"
            density="compact"
            hide-details></v-text-field>
    </v-row>
    <v-row>
        <v-col cols="4" class="py-0">
            <v-checkbox
                v-model="localSolution.forwardingToDealer"
                @update:model-value="solutionUpdated"
                label="Forwarding to dealer"
                hide-details
                class="shrink mr-2 my-2"></v-checkbox>
        </v-col>
    </v-row>
    <v-row>
        <v-col cols="4" class="py-0">
            <v-checkbox
                v-model="localSolution.repairCostCovered"
                @update:model-value="solutionUpdated"
                label="Repair cost covered"
                hide-details
                class="shrink mr-2 my-2"></v-checkbox>
        </v-col>
    </v-row>
    <v-row>
        <v-col cols="4" class="py-0">
            <v-checkbox
                v-model="localSolution.partsCostCovered"
                @update:model-value="solutionUpdated"
                label="Part cost covered"
                hide-details
                class="shrink mr-2 my-2"></v-checkbox>
        </v-col>
    </v-row>
    <v-row>
        <v-col cols="4" class="py-0">
            <v-checkbox
                v-model="localSolution.warrantyExt"
                @update:model-value="solutionUpdated"
                label="BSI / Warranty ext."
                hide-details
                class="shrink mr-2 my-2"></v-checkbox>
        </v-col>
    </v-row>
    <v-row>
        <v-col cols="4" class="py-0">
            <v-checkbox
                v-model="localSolution.connectedDriveUpdate"
                @update:model-value="solutionUpdated"
                label="Connected Drive Upgrade"
                hide-details
                class="shrink mr-2 my-2"></v-checkbox>
        </v-col>
    </v-row>
    <v-row>
        <v-col cols="4" class="py-0">
            <v-checkbox
                v-model="localSolution.loanerCar"
                @update:model-value="solutionUpdated"
                label="Loaner / Courtesy car"
                hide-details
                class="shrink mr-2 my-2"></v-checkbox>
        </v-col>
    </v-row>
    <v-row>
        <v-col cols="4" class="py-0">
            <v-checkbox
                v-model="localSolution.vehicleCharging"
                @update:model-value="solutionUpdated"
                label="Vehicle charging"
                hide-details
                class="shrink mr-2 my-2"></v-checkbox>
        </v-col>
    </v-row>
    <v-row>
        <v-col cols="4" class="py-0">
            <v-checkbox
                v-model="localSolution.vehicleTreatment"
                @update:model-value="solutionUpdated"
                label="Vehicle Treatment"
                hide-details
                class="shrink mr-2 my-2"></v-checkbox>
        </v-col>
    </v-row>
    <v-row>
        <v-col cols="4" class="py-0">
            <v-checkbox
                v-model="localSolution.experienceVoucher"
                @update:model-value="solutionUpdated"
                label="Experience voucher / Event"
                hide-details
                class="shrink mr-2 my-2"></v-checkbox>
        </v-col>
    </v-row>
    <v-row>
        <v-col cols="4" class="py-0">
            <v-checkbox
                v-model="localSolution.lifestyleVoucher"
                @update:model-value="solutionUpdated"
                label="Lifestyle voucher"
                hide-details
                class="shrink mr-2 my-2"></v-checkbox>
        </v-col>
    </v-row>
    <v-row>
        <v-col cols="4" class="py-0">
            <v-checkbox
                v-model="localSolution.discountOnNextCar"
                @update:model-value="solutionUpdated"
                label="Discount on next car"
                hide-details
                class="shrink mr-2 my-2"></v-checkbox>
        </v-col>
    </v-row>
    <v-row>
        <v-col cols="4" class="py-0">
            <v-checkbox
                v-model="localSolution.cashPayment"
                @update:model-value="solutionUpdated"
                label="Cash payment / vehcile payment"
                hide-details
                class="shrink mr-2 my-2"></v-checkbox>
        </v-col>
    </v-row>
    <v-row>
        <v-col cols="4" class="py-0">
            <v-checkbox
                v-model="localSolution.buyBack"
                @update:model-value="solutionUpdated"
                label="Buy back"
                hide-details
                class="shrink mr-2 my-2"></v-checkbox>
        </v-col>
    </v-row>
</div>